export default __webpack_public_path__ + "static/media/DownArrow.0a390b96.svg";